import { createFileRoute } from '@tanstack/react-router';
import DocumentManager from 'containers/DocumentManager';

export const Route = createFileRoute('/_authenticated/documentManager')({
  component: DocumentManager,
});
